import { Injectable } from '@angular/core';
import { Resolve, ActivatedRouteSnapshot, Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { AmplifyTranslationsService } from '../global-services/amplify-translations.service';

@Injectable({
  providedIn: 'root'
})
export class LanguageResolver implements Resolve<string> {

  private readonly supportedLanguages = ['pl', 'en', 'pseudo'];
  private readonly languageMapping: { [key: string]: string } = {
    'pl': 'pl_PL',
    'en': 'en_US',
    'pseudo': 'pseudo_PL'
  };

  constructor(
    private translateService: TranslateService,
    private amplifyTranslationsService: AmplifyTranslationsService,
    private router: Router
  ) {}

  resolve(route: ActivatedRouteSnapshot): string {
    const langParam = route.paramMap.get('lang');

    // If no language parameter, return default without redirecting
    if (!langParam) {
      const defaultLang = 'pl_PL';
      this.setLanguage(defaultLang);
      return defaultLang;
    }

    // Validate language parameter
    if (!this.supportedLanguages.includes(langParam)) {
      // Invalid language, return default without redirecting
      const defaultLang = 'pl_PL';
      this.setLanguage(defaultLang);
      return defaultLang;
    }

    const fullLanguageCode = this.languageMapping[langParam];

    // Set the language in the app
    this.setLanguage(fullLanguageCode);

    return fullLanguageCode;
  }

  private setLanguage(languageCode: string): void {
    try {
      this.translateService.use(languageCode);
      localStorage.setItem('selectedLanguage', languageCode);
      this.amplifyTranslationsService.setAmplifyLanguage(languageCode);
    } catch (error) {
      console.error('Error setting language:', error);
    }
  }
}
